export const kebabToSentenceCase = input => `${input.substring(0, 1).toUpperCase()}${input.substring(1).replace(/-([a-z])/ig, (matches, nextChar) => ` ${nextChar.toUpperCase()}`)}`;

export const toKebabCase = input => input.toLowerCase().trim().replace(/ /g, () => '-');

export const isVowel = input => ['a', 'i', 'e', 'o', 'u'].includes(input.toLowerCase());
